<template>
    <div class="quickpay-settings">
        <LayoutSettings2Cols>
            <template #content>
                <QuickpaySettingsPitch />
                <QuickpaySettingsPaymentPartners
                    :providerStatuses="providerStatuses"
                    :isLoading="isLoading"
                />
                <QuickpaySettingsBlockPreferences
                    :providerStatuses="providerStatuses"
                    :isLoadingProviders="isLoading"
                />
            </template>
            <template #sidebar-right>
                <QuickpaySettingsRightSidebar />
            </template>
        </LayoutSettings2Cols>
    </div>
</template>

<script setup lang="ts">
import { ref, inject, onMounted, onBeforeUnmount } from 'vue';
import { Translator, PushToast } from 'js/shims-vue';
import QuickpaySettingsPitch from 'vcomponents/quickpay/settings/QuickpaySettingsPitch.vue';
import QuickpaySettingsPaymentPartners from 'vcomponents/quickpay/settings/QuickpaySettingsPaymentPartners.vue';
import QuickpaySettingsBlockPreferences from 'vcomponents/quickpay/settings/QuickpaySettingsBlockPreferences.vue';
import { fetchPaymentProviders } from 'api/quickpay/quickpayService';
import QuickpaySettingsRightSidebar from 'vcomponents/quickpay/settings/QuickpaySettingsRightSidebar.vue';
import LayoutSettings2Cols from 'vcomponents/common/layout/content/LayoutSettings2Cols.vue';

const $t = inject('$t') as Translator;
const $pushToast = inject('$pushToast') as PushToast;

const providerStatuses = ref<Record<string, string>>({});
const isLoading = ref(true);

const loadProviders = async (): Promise<void> => {
    try {
        const response = await fetchPaymentProviders();
        const data = response.data as { data: { name: string; status: string }[] };
        const statusMap: Record<string, string> = {};
        // API provider.name must match dictionary provider.id (ex: 'stripe', 'gocardless')
        for (const provider of data.data) {
            statusMap[provider.name] = provider.status;
        }
        providerStatuses.value = statusMap;
    } catch {
        $pushToast({
            type: 'error',
            icon: true,
            text: $t.__('common.labels.toast.error'),
        });
    } finally {
        isLoading.value = false;
    }
};

onMounted(() => {
    loadProviders();
    EventBus.on('stancer:settings:saved', loadProviders);
});

onBeforeUnmount(() => {
    EventBus.off('stancer:settings:saved', loadProviders);
});
</script>